import { alpha } from "@mui/material/styles";
import { PaletteOptions } from "@mui/material/styles";

import { sharedNeutrals } from "./shared";

export const lightPalette: PaletteOptions = {
  action: {
    disabled: "rgba(65, 70, 81, 0.45)",
    disabledBackground: "#F5F6F7",
    focus: "rgba(var(--mui-palette-primary-mainChannel) / 0.12)",
    hover: "#FAFAFA",
    selected: "var(--mui-palette-primary-main)",
    // Given explicitly so MUI does not try (and warn) to derive the channel
    // from a `var()` it cannot parse.
    selectedChannel: "var(--mui-palette-primary-mainChannel)"
  },
  background: {
    default: sharedNeutrals.white,
    paper: sharedNeutrals.white
  },
  border: {
    accent: "var(--mui-palette-primary-main)",
    default: "#535862",
    // 20% darker than it was. A card on a white page is separated only by
    // this line, and at 6% black its edge was hard to find.
    hairline: alpha("#000000", 0.072),
    strong: "#D5D7DA",
    subtle: "#E1E1E1"
  },
  divider: "#D5D7DA",
  error: {
    contrastText: sharedNeutrals.white,
    light: "rgba(240, 68, 56, 0.08)",
    main: "#E84B27"
  },
  grey: {
    100: "#FEFEFE",
    200: "#F5F6F7",
    300: "#FAFAFA",
    400: "#D5D7DA",
    500: "#9F9F9F",
    600: "#6B7280",
    700: "#535862",
    800: "#414651",
    900: "#0A0D12"
  },
  icon: {
    default: "#6B7280",
    inverse: sharedNeutrals.white,
    muted: "#9F9F9F",
    strong: "#181D27"
  },
  info: {
    main: "#706DFF"
  },
  mode: "light",
  overlay: {
    backdrop: "rgba(255, 255, 255, 0.6)",
    scrim: "rgba(10, 13, 18, 0.6)"
  },
  secondary: {
    contrastText: sharedNeutrals.white,
    dark: "#0A0D12",
    light: "#6B7280",
    main: "#414651"
  },
  success: {
    contrastText: sharedNeutrals.white,
    main: "#1B9B76"
  },
  surface: {
    base: "#FAFAFA",
    elevated: "#FFFFFF",
    inset: "#F5F5F5",
    overlay: "#FDFDFE",
    page: "rgba(255, 255, 255, 0.8)",
    subtle: "#FCFCFD"
  },
  text: {
    disabled: "#88909F",
    inverse: sharedNeutrals.white,
    primary: "#181D27",
    quaternary: "#717680",
    secondary: "#535862",
    subtle: "#D5D7DA",
    tertiary: "#414651"
  },
  warning: {
    main: "#E98945"
  }
};
